<template>
    <c-dialog ref="dialog" mode="slide" width="40vw" mask-close
              @close="dialogFormEditConfirm($refs.purchaseCheckForm, arguments)"
              @resolve="submitHandle" :button="!detail">
        <template #head>
            <div v-if="detailData.produce_unique_code" class="m-detail-tag flex-center-cross">
                <label>{{ detailData.produce_unique_code }}</label>
                <c-state tag async dict="UNIQUE_CODE_STATE" :value="detailData.state"></c-state>
            </div>
        </template>
        <c-form ref="purchaseCheckForm" column="1" vertical unit-width="100%">
            <c-form link-parent>
				<c-form-item label="背贴码" required>
					<c-input name="produce_unique_code" v-model="produce_unique_code" placeholder="请输入/扫描背贴码"
							 @input="clearCodeError()"
							 @enter="checkProductCode()"
							 @change="checkProductCode()"
					>
						<template #appendIcon><i class="tf-scan"></i></template>
					</c-input>
				</c-form-item>
                <c-form-item label="IMEI码" required>
                    <c-input name="produce_imei" placeholder="请输入，不填将自动生成" :disabled="detail"></c-input>
                </c-form-item>
                <c-form-item label="选择产品型号" required>
                    <template #default="{data}">
						<div class="flex" style="gap: 20px;">
							<c-select name="category_id"
									  async @search="searchCategory"
									  @change="changeSelect($event, detailData,'categoryId')"
									  :value-data="detailData.productCategory"
									  v-model="detailData.category_id"
									  :disabled="detail"
									  :clear="false"
									  placeholder="类目"
							>
								<template #option="{data, selected}">
									<select-option :name="data.name" :selected="selected"></select-option>
								</template>
							</c-select>
							<c-select name="brand_id"
									  async @search="searchBrand(detailData,arguments[0], arguments[1])"
									  @change="changeSelect($event, detailData,'brandId')"
									  :value-data="detailData.productBrand"
									  v-model="detailData.brand_id"
									  :disabled="!detailData.category_id || detail"
									  :clear="false"
									  placeholder="品牌"
							>
								<template #option="{data, selected}">
									<select-option :name="data.name" :selected="selected"></select-option>
								</template>
							</c-select>
							<c-select name="spu_model_id"
									  async @search="searchModel(detailData,arguments[0], arguments[1])"
									  @change="changeSelect($event, detailData,'modelId')"
									  :value-data="detailData.productModel"
									  v-model="detailData.spu_model_id"
									  :disabled="!detailData.brand_id || detail"
									  :clear="false"
									  placeholder="型号"
							>
								<template #option="{data, selected}">
									<select-option :name="data.name" :selected="selected"></select-option>
								</template>
							</c-select>
						</div>
                    </template>
                </c-form-item>
                <c-form-item label="等级" required>
                    <c-radio-group name="level_type" v-model="detailData.level_type" :options="levelTypeOptions"
                                   :disabled="detail"></c-radio-group>
                </c-form-item>
				<c-form-item label="演示机" required>
					<c-radio-group name="is_demo" v-model="detailData.is_demo" :options="yesOrNoOptions"
								   :disabled="detail"></c-radio-group>
				</c-form-item>
                <c-form-item label="采购价" required>
					<c-input name="purchase_price" v-model="detailData.purchase_price" type="number" decimal="2"
							 :range="[0,999999]" placeholder="采购价" append-text="元"
							 :disabled="detail" :clear="false"></c-input>
                </c-form-item>
                <c-form-item label="同行价">
					<c-input name="market_price" v-model="detailData.market_price" type="number" decimal="2"
							 :range="[0,999999]" placeholder="同行价" append-text="元"
							 :disabled="detail" :clear="false"></c-input>
                </c-form-item>
                <c-form-item label="零售价">
					<c-input name="retail_price" v-model="detailData.retail_price" type="number" decimal="2"
							 :range="[0,999999]" placeholder="零售价" append-text="元"
							 :disabled="detail" :clear="false"></c-input>
                </c-form-item>


                <!--其他动态属性-->
                <c-form v-show="attributeList && attributeList.length" ref="form" name="attribute_value_json"
                        link-parent>
                    <c-form-item v-for="(item, i) in attributeList" :key="i" :label="item.attribute_name" :required="item.required==1">
                        <c-input v-if="item.attribute_type == 2"
                                 type="number"
                                 :name="'attribute_parent_id_'+item.parent_id"
                                 :decimal="item.decimal ? item.decimal : 0"
                                 :disabled="detail"
                        ></c-input>

                        <c-datetime v-else-if="item.attribute_type == 3"
                                    :name="'attribute_parent_id_'+item.parent_id"
                                    :type="item.config_json.format.split('|')[1]"
                                    :format="item.config_json.format.split('|')[0]"
                                    :time-accuracy="item.config_json.format.split('|')[2]"
                                    :disabled="detail"
                        ></c-datetime>

                        <template v-else-if="item.attribute_type == 4">
                            <c-radio-group :name="'attribute_parent_id_'+item.parent_id" :options="item.attribute_options" :disabled="detail">
                            </c-radio-group>
                        </template>

                        <c-upload-file v-else-if="item.attribute_type == 5"
                                       :name="'attribute_parent_id_'+item.parent_id"
                                       type="file"
                                       :multiple="(item.config_json.multiple && item.config_json.multiple == 1) ? 30 : false"
                                       :disabled="detail"
                        ></c-upload-file>

                        <c-upload-file v-else-if="item.attribute_type == 6"
                                       :name="'attribute_parent_id_'+item.parent_id"
                                       type="image"
                                       :multiple="(item.config_json.multiple && item.config_json.multiple == 1) ? 30 : false"
                                       :disabled="detail"
                        ></c-upload-file>

                        <c-input v-else
                                 type="text"
                                 :name="'attribute_parent_id_'+item.parent_id"
                                 :disabled="detail"
                        ></c-input>
                    </c-form-item>
                </c-form>
            </c-form>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'purchaseOrderCheck',

	props: {
		type: {
			type: [String, Number],
			default: 1
		}
	},

    computed: {
		...mapState(['yesOrNoOptions']),
        //自定义参数必填校验
        rule() {
            let rule = {};
            this.attributeList.map(item => {
                if (item.required == 1) {
                    rule[`attribute_value_json.attribute_parent_id_${item.parent_id}`] = `${item.attribute_name}不能为空`;
                }
            });
            return rule;
        }
    },
    data() {
        return {
            detail: false,             //是否仅查看 1=仅查看
            produce_unique_code: '',//背贴码信息
			produce_code_id: 0,
			purchase_order_id: 0,
            detailData: {
				category_id: '',
				brand_id: '',
				color_id: '',
				spu_model_id: '',
				memory_id: '',
				is_demo: 2
			},
            levelTypeOptions: [],
            attributeList: [],
            spuModelId: 0,
            selctedAttributeMap: {}
        }
    },

    watch: {
    },

    methods: {
        initData() {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: 'LEVEL_TYPE'
                },
                success: data => {
                    this.levelTypeOptions = data;
                }
            })
        },
        /*******通过商品的【机型】查询该机型需要填写的参数集合*******************/
        getAttributeListByModel(init_type) {
            this.request({
                url: '/spu/model/attribute/list',
                data: {
					type: 1,            //默认使用B端数据
                    model_id: this.spuModelId
                },
                loading: true,
                success: data => {
                    this.attributeList = data;
                    if (init_type){
                        //赋值已选中的属性
                        setTimeout(() => {
                            //合并对象
                            const mergedObj = Object.assign({}, this.detailData, this.detailData.attribute_value_json);
                            //采购订单基本信息
                            this.$refs.purchaseCheckForm.set(mergedObj);
                        }, 50);
                    }
                }
            });
        },
        //打开弹窗
        open(detail, data) {
            this.detail = detail;
			this.purchase_order_id = data.id;
            this.produce_unique_code = data.produce_unique_code;
            //清空表单数据
            this.$refs.purchaseCheckForm.clear();
            this.initData();
            //查询详情
			if(this.produce_unique_code){
            	this.getPurchaseOrderProductDetail();
			}
            this.$refs.dialog.open({
                title: detail ? '采购商品详情' : '确认收货并初检'
            });
        },
		/*********清除行内背贴码校验错误提示**********/
		clearCodeError() {
			if (this.detailData.code_error) {
				this.$set(this.detailData, 'code_error', '');
			}
		},
		/*********行内背贴码校验（编辑时直接调用后端接口）**********/
		checkProductCode() {
			var code = (this.produce_unique_code || '').trim();
			if (this.detail) {
				return;
			}
			//正在校验中或已校验通过且值未变化时，不重复请求
			if (this.detailData.code_checking || (code && this.detailData.code_checked === code)) {
				return;
			}
			this.$set(this.detailData, 'code_error', '');
			if (!code) {
				return;
			}
			this.$set(this.detailData, 'code_checking', true);
			this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 1  //1=背贴码绑定商品
                },
				success: data => {
					if (data.main_state != 1 && data.main_state != 2) {
						this.$set(this.detailData, 'code_error', '当前商品主状态非【待绑定】，无法添加');
						return;
					}
					if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
						this.$set(this.detailData, 'code_error', '当前背贴码已关联其他采购单，无法添加');
						return;
					}
					this.produce_code_id = data.id;
					//校验通过，记录已校验的值，避免重复请求
					this.$set(this.detailData, 'code_checked', code);
					this.$set(this.detailData, 'code_error', '');
				},
				fail: (code, obj, message) => {
					//错误显示在行内输入框下方，不再触发全局弹窗
					this.$set(this.detailData, 'code_error', message || '背贴码校验失败，请检查');
					return false;
				},
				complete: () => {
					this.$set(this.detailData, 'code_checking', false);
				}
			});
		},
        /**************变更 下拉框数据******************/
        changeSelect(selectData, rowData, type) {
            if (type == 'categoryId') {
                if (selectData && selectData.value) {
					this.$set(rowData, 'brand_id', 0);
                    rowData.brand_id = 0;
                    rowData.productbrand = [];
                    rowData.spu_model_id = 0;
                    rowData.productModel = [];
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                }
            } else if (type == 'brandId') {
                if (selectData && selectData.value) {
                    rowData.spu_model_id = 0;
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                    rowData.productModel = [];
                }
            } else if (type == 'modelId') {
                if (selectData && selectData.value) {
					this.spuModelId = selectData.value;
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                    this.getAttributeListByModel();
                }
            }
        },
        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌****************/
        searchBrand(data, keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: data.category_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(data, keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: data.category_id,
                    brand_id: data.brand_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索采购商品详情*******************/
        getPurchaseOrderProductDetail() {
            this.request({
                url: '/purchase/order/product/detail',
                data: {
                    produce_unique_code: this.produce_unique_code
                },
                loading: true,
                success: data => {
                    data.level_type = data.level_type||'';
                    this.detailData = data||{};
                    this.produce_code_id = this.detailData.id;
                    this.spuModelId = this.detailData.spu_model_id || 0;
                    this.selctedAttributeMap = this.detailData.selctedAttributeMap || {};
                    if(this.spuModelId){
                        this.getAttributeListByModel(true);
                    }
                    //合并对象
                    const mergedObj = Object.assign({}, this.detailData, this.detailData.attribute_value_json);
                    //采购订单基本信息
                    this.$refs.purchaseCheckForm.set(mergedObj);
                }
            });
        },

        /*******提交编辑数据********************/
        submitHandle(stop, next) {
            stop();
            this.$refs.purchaseCheckForm.submit({
                url: '/bidding/purchase/order/receipt',
                rule: {
					produce_unique_code: '请输入背贴码',
                    category_id: '请选择类目',
                    brand_id: '请选择品牌',
                    spu_model_id: '请选择机型',
                    level_type: '请选择等级',
					is_demo: '请选择是否演示机',
                    purchase_price: '请输入采购价',
                    ...this.rule
                },
                dataFormatter: data => {
					data.produce_code_id = this.produce_code_id;
					data.purchase_order_id = this.purchase_order_id;
					data.market_price = this.market_price || undefined;
					data.retail_price = data.retail_price || undefined;
					let submitData = {
						product_list: [data],
						purchase_order_id: this.purchase_order_id,
						...data
					}
                    return submitData;
                },
                success: () => {
                    next();
                    this.$message({
                        type: 'success',
                        message: '初检数据录入成功',
                    });
                    //刷新页面
                    this.$emit('resolve');
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>